import React from "react";
import { AuditDrawer } from "../../../../components/AuditDrawer";

interface AuditLogDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  logData: any;
}

const CustomSeparator = () => <div className="h-px w-full bg-gray-200 my-2" />;

const SingleAuditLogDrawer: React.FC<AuditLogDrawerProps> = ({
  isOpen,
  onClose,
  logData,
}) => {

  const { user, timestamp, module, ["device type"]: device } = logData || {};


  return (
    <AuditDrawer isOpen={isOpen} onClose={onClose} title="Audit Log Details">
      <div className="max-h-[70vh] space-y-4 pr-1 mt-6">

        {/* user*/}
        <div className="flex w-full justify-between items-center">
          <h4 className="font-medium text-gray-600">User</h4>
          <p className="text-gray-800 font-bold text-right">
            {user || "n/a"}
          </p>
        </div>

        <CustomSeparator />

        {/* time */}
        <div className="flex w-full justify-between items-start">
          <h4 className="font-medium text-gray-600">Time</h4>
          <p className="text-gray-800 font-bold text-right max-w-[300px]">
            {timestamp || "n/a"}
          </p>
        </div>

        <CustomSeparator />

        {/* module */}
        <div className="flex w-full justify-between items-start">
          <h4 className="font-medium text-gray-600">Module</h4>
          <p className="text-gray-800 font-bold text-right max-w-[300px]">
            {module || "n/a"}
          </p>
        </div>
        <CustomSeparator />

        {/* module */}
        <div className="flex w-full justify-between items-start">
          <h4 className="font-medium text-gray-600">Device</h4>
          <p className="text-gray-800 font-bold text-right max-w-[300px]">
            {device || "n/a"}
          </p>
        </div>


        <CustomSeparator />

   
      </div>
    </AuditDrawer>
  );
};

export default SingleAuditLogDrawer;
